"use client";

import { DesktopSidebar } from "@/components/ui/desktop-sidebar";
import { MobileNav } from "@/components/ui/mobile-nav";
import { ChatProvider } from "@/contexts/ChatContext";
import { I18nextProvider } from "react-i18next";
import i18n from "@/app/i18n/i18n";
import { ChatApiUrls } from "@/types/chat";
import { SessionAutoIndex } from "@/components/SessionAutoIndex";

const apiUrls: ChatApiUrls = {
  chatApiUrl: "/api/agent/chat-messages",
  conversationsApiUrl: "/api/agent/conversations",
  messagesFeedbackApiUrl: "/api/agent/messages",
  uploadApiUrl: "/api/agent/files/upload",
  captionApiUrl: "/api/files/get-caption",
};

export default function ProtectedLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <I18nextProvider i18n={i18n}>
      <ChatProvider apiUrls={apiUrls}>
        <SessionAutoIndex />
        <div className="flex h-screen w-full overflow-hidden bg-background text-foreground">
          <DesktopSidebar />
          <div className="flex flex-1 flex-col min-w-0">
            <MobileNav />
            <main className="relative flex-1 overflow-y-auto pt-14 md:pt-0">
              {children}
            </main>
          </div>
        </div>
      </ChatProvider>
    </I18nextProvider>
  );
}
